var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrokenRobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 651.67 626.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#205477;}.cls-12,.cls-2,.cls-20,.cls-4,.cls-6{mix-blend-mode:multiply;}.cls-3{fill:#353847;}.cls-5,.cls-6{fill:#70628c;}.cls-7{fill:#eaeff3;}.cls-8{fill:#d3dde6;}.cls-9{fill:#828282;}.cls-16,.cls-17,.cls-18,.cls-21,.cls-9{mix-blend-mode:screen;}.cls-10{fill:#adbecc;}.cls-11,.cls-12{fill:#339ca6;}.cls-13{fill:#f5f7f9;}.cls-14{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:2px;}.cls-15{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_130);}.cls-16{fill:#3b3b3b;}.cls-17{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_66);}.cls-18{fill:#b1b3b4;}.cls-19{fill:#888c99;}.cls-20{fill:#a9a3b5;}.cls-21{fill:#d3d3d3;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_130",
    cx: 672.93,
    cy: 334.52,
    r: 12.64,
    gradientTransform: "translate(593.77 -471.13) rotate(81.61)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#58585a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#474548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#29262a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#2c292d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#363437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3e3d40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#39383b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#242425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#080809"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_66",
    x1: 672.93,
    y1: 339.16,
    x2: 672.93,
    y2: 323.23,
    gradientTransform: "translate(-352.69 8.11) rotate(-8.19)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\xD1\\xEB\\xEE\\xE9_1",
    "data-name": "\\xD1\\xEB\\xEE\\xE9 1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 362.99,
    cy: 613.46,
    rx: 288.68,
    ry: 12.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M340.46,179.27a4.21,4.21,0,0,1-4.77-3.57l-8-55.6a4.21,4.21,0,0,1,8.34-1.2l8,55.6A4.2,4.2,0,0,1,340.46,179.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M384.94,172.87a4.22,4.22,0,0,1-4.77-3.57L362.57,47a4.21,4.21,0,0,1,8.34-1.2l17.6,122.32A4.2,4.2,0,0,1,384.94,172.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M399.19,114.07l-33.37,4.8a4.21,4.21,0,0,1-1.2-8.34l33.37-4.8a4.21,4.21,0,1,1,1.2,8.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M384.86,93.43l-33.36,4.8a4.21,4.21,0,0,1-1.2-8.34l33.36-4.8a4.21,4.21,0,1,1,1.2,8.34Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M385.59,91.3,350.2,96.39a4.45,4.45,0,0,1-3.2-.77,4.21,4.21,0,0,0,4.5,2.61l33.36-4.8a4.21,4.21,0,0,0,3.59-3.78A4.47,4.47,0,0,1,385.59,91.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M399.91,111.94,364.52,117a4.45,4.45,0,0,1-3.2-.77,4.2,4.2,0,0,0,4.5,2.61l33.37-4.8a4.21,4.21,0,0,0,3.58-3.78A4.47,4.47,0,0,1,399.91,111.94Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 281.81,
    y: 350.19,
    width: 56.17,
    height: 101.11,
    transform: "translate(-53.91 48.22) rotate(-8.19)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "305.59 452.45 289.3 454.79 274.9 354.71 302.51 350.74 305.59 452.45"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 448.62,
    y: 326.19,
    width: 56.17,
    height: 101.11,
    transform: "translate(-48.8 71.73) rotate(-8.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 448.8,
    y: 328.69,
    width: 21.07,
    height: 101.11,
    transform: "translate(-49.33 69.28) rotate(-8.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 329.16,
    y: 227.22,
    width: 89.88,
    height: 56.17,
    transform: "translate(-32.55 55.88) rotate(-8.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 327.36,
    y: 227.35,
    width: 89.88,
    height: 30.84,
    transform: "translate(-30.78 55.49) rotate(-8.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M267.49,312.78h0a29.66,29.66,0,0,1,29.66,29.66V474.12a29.65,29.65,0,0,1-29.65,29.65h0a29.66,29.66,0,0,1-29.66-29.66V342.44A29.66,29.66,0,0,1,267.49,312.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M279.41,315.3a29.56,29.56,0,0,1,9.29,21.52l0,131.67a29.63,29.63,0,0,1-41.59,27.15,29.63,29.63,0,0,0,50-21.53l0-131.68A29.65,29.65,0,0,0,279.41,315.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M263.38,328.47a7,7,0,1,1-7-7A7,7,0,0,1,263.38,328.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M278.71,356.32H256.24a4.22,4.22,0,0,1,0-8.43h22.47a4.22,4.22,0,0,1,0,8.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M254.84,354.92a4.21,4.21,0,0,1,4.21-4.22h22.47a4.43,4.43,0,0,1,1.21.19,4.22,4.22,0,0,0-4-3H256.24a4.2,4.2,0,0,0-1.21,8.23A4.3,4.3,0,0,1,254.84,354.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M278.72,378.78H256.25a4.22,4.22,0,1,1,0-8.43h22.47a4.21,4.21,0,1,1,0,8.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M254.84,377.39a4.22,4.22,0,0,1,4.21-4.22h22.47a4.32,4.32,0,0,1,1.21.19,4.19,4.19,0,0,0-4-3H256.25a4.2,4.2,0,0,0-1.21,8.23A4,4,0,0,1,254.84,377.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M278.72,401.25H256.25a4.22,4.22,0,0,1,0-8.43h22.47a4.21,4.21,0,0,1,0,8.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M254.85,399.86a4.21,4.21,0,0,1,4.21-4.22h22.47a4.43,4.43,0,0,1,1.21.19,4.22,4.22,0,0,0-4-3H256.25a4.2,4.2,0,0,0-1.21,8.23A4.3,4.3,0,0,1,254.85,399.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M278.73,423.72H256.26a4.22,4.22,0,1,1,0-8.43h22.46a4.21,4.21,0,1,1,0,8.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M254.85,422.32a4.22,4.22,0,0,1,4.21-4.21h22.47a4.32,4.32,0,0,1,1.21.19,4.2,4.2,0,0,0-4-3H256.26a4.2,4.2,0,0,0-1.21,8.23A4,4,0,0,1,254.85,422.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M278.73,446.19H256.26a4.22,4.22,0,0,1,0-8.43h22.47a4.21,4.21,0,0,1,0,8.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M254.86,444.79a4.21,4.21,0,0,1,4.21-4.21h22.47a4.43,4.43,0,0,1,1.21.19,4.22,4.22,0,0,0-4-3H256.26a4.2,4.2,0,0,0-1.21,8.23A4.32,4.32,0,0,1,254.86,444.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M278.74,468.66H256.27a4.22,4.22,0,0,1,0-8.43h22.47a4.21,4.21,0,1,1,0,8.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M254.86,467.26a4.22,4.22,0,0,1,4.21-4.21h22.47a4.32,4.32,0,0,1,1.21.19,4.2,4.2,0,0,0-4-3H256.26a4.2,4.2,0,0,0-1.2,8.23A4,4,0,0,1,254.86,467.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M536.24,464.66h0a29.64,29.64,0,0,1-33.57-25.13L483.91,309.2A29.66,29.66,0,0,1,509,275.62h0a29.65,29.65,0,0,1,33.58,25.13l18.76,130.33A29.66,29.66,0,0,1,536.24,464.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M521.23,276.41a29.51,29.51,0,0,1,12.25,20l18.76,130.33A29.66,29.66,0,0,1,527.1,460.3h0a29.53,29.53,0,0,1-12.18-.79,29.53,29.53,0,0,0,21.32,5.15h0a29.66,29.66,0,0,0,25.14-33.58L542.62,300.75A29.65,29.65,0,0,0,521.23,276.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M507.23,291.72a7,7,0,1,1-8-6A7,7,0,0,1,507.23,291.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M526.36,317.11l-22.24,3.2a4.21,4.21,0,0,1-1.2-8.34l22.24-3.2a4.21,4.21,0,1,1,1.2,8.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M502.53,319.12a4.21,4.21,0,0,1,3.57-4.77l22.24-3.2a4.21,4.21,0,0,1,1.23,0,4.21,4.21,0,0,0-4.41-2.4L502.92,312a4.2,4.2,0,0,0,0,8.32A4.21,4.21,0,0,1,502.53,319.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M529.56,339.35l-22.24,3.2a4.21,4.21,0,0,1-1.2-8.34l22.24-3.2a4.21,4.21,0,0,1,1.2,8.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M505.73,341.36a4.22,4.22,0,0,1,3.57-4.77l22.24-3.2a4.21,4.21,0,0,1,1.23,0,4.21,4.21,0,0,0-4.41-2.4l-22.24,3.2a4.2,4.2,0,0,0,0,8.32A4.21,4.21,0,0,1,505.73,341.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M532.76,361.59l-22.24,3.2a4.21,4.21,0,1,1-1.2-8.34l22.24-3.2a4.21,4.21,0,0,1,1.2,8.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M508.93,363.6a4.22,4.22,0,0,1,3.57-4.77l22.24-3.2a4.21,4.21,0,0,1,1.23,0,4.21,4.21,0,0,0-4.41-2.4l-22.24,3.2a4.2,4.2,0,0,0,0,8.32A4.21,4.21,0,0,1,508.93,363.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M536,383.83,513.72,387a4.21,4.21,0,1,1-1.2-8.34l22.24-3.2a4.21,4.21,0,0,1,1.2,8.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M512.13,385.84a4.22,4.22,0,0,1,3.57-4.77l22.24-3.2a4.21,4.21,0,0,1,1.23,0,4.21,4.21,0,0,0-4.41-2.4l-22.24,3.2a4.2,4.2,0,0,0,0,8.32A4.21,4.21,0,0,1,512.13,385.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M539.16,406.07l-22.24,3.2a4.21,4.21,0,1,1-1.2-8.34l22.24-3.2a4.21,4.21,0,0,1,1.2,8.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M515.33,408.08a4.22,4.22,0,0,1,3.57-4.77l22.24-3.2a4.21,4.21,0,0,1,1.23,0,4.21,4.21,0,0,0-4.41-2.4l-22.24,3.2a4.2,4.2,0,0,0,0,8.32A4.21,4.21,0,0,1,515.33,408.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M542.36,428.31l-22.24,3.2a4.21,4.21,0,1,1-1.2-8.34l22.24-3.2a4.21,4.21,0,0,1,1.2,8.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M518.53,430.32a4.22,4.22,0,0,1,3.57-4.77l22.24-3.2a4.21,4.21,0,0,1,1.23,0,4.21,4.21,0,0,0-4.41-2.4l-22.24,3.2a4.2,4.2,0,0,0,0,8.32A4.21,4.21,0,0,1,518.53,430.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M481.63,529.27l-133.45,19.2L311.52,293.63a12.17,12.17,0,0,1,10.31-13.78l109.35-15.73A12.17,12.17,0,0,1,445,274.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M431.18,264.12l-11.12,1.6A12.17,12.17,0,0,1,433.84,276L469.75,525.6,347.42,543.2l.76,5.27,133.45-19.2L445,274.43A12.17,12.17,0,0,0,431.18,264.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M362.78,531.59a5.61,5.61,0,0,1-6.36-4.76L323.5,298.06a5.62,5.62,0,0,1,11.12-1.6l32.92,228.77A5.62,5.62,0,0,1,362.78,531.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 362,
    y: 394.2,
    width: 67.41,
    height: 22.47,
    transform: "translate(-53.71 60.49) rotate(-8.19)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "363.92 401.49 427.87 392.29 427.46 389.51 360.74 399.11 363.94 421.35 366.72 420.95 363.92 401.49"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 368.4,
    y: 438.68,
    width: 67.41,
    height: 22.47,
    transform: "matrix(0.99, -0.14, 0.14, 0.99, -59.98, 61.85)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "370.32 445.97 434.26 436.77 433.87 433.99 367.14 443.59 370.34 465.83 373.12 465.43 370.32 445.97"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 374.8,
    y: 483.16,
    width: 67.41,
    height: 22.47,
    transform: "translate(-66.24 63.22) rotate(-8.19)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "376.72 490.45 440.67 481.25 440.26 478.47 373.54 488.07 376.74 510.31 379.52 509.91 376.72 490.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M352.65,364.57a3.45,3.45,0,0,1-3.91-2.93l-6.55-45.52a3.45,3.45,0,0,1,6.83-1l6.55,45.53A3.45,3.45,0,0,1,352.65,364.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M351.34,363.59l-6.55-45.53a3.45,3.45,0,0,1,2.93-3.9,3.35,3.35,0,0,1,1,0,3.44,3.44,0,0,0-6.53,1.94l6.55,45.52a3.44,3.44,0,0,0,2.91,2.91A3.38,3.38,0,0,1,351.34,363.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M370.86,362A3.45,3.45,0,0,1,367,359l-6.55-45.53a3.45,3.45,0,0,1,6.83-1L373.78,358A3.45,3.45,0,0,1,370.86,362Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M369.56,361,363,315.44a3.43,3.43,0,0,1,2.92-3.9,3.34,3.34,0,0,1,1,0,3.44,3.44,0,0,0-6.53,1.93L367,359a3.44,3.44,0,0,0,2.91,2.91A3.36,3.36,0,0,1,369.56,361Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M389.07,359.33a3.46,3.46,0,0,1-3.91-2.93l-6.55-45.53a3.45,3.45,0,0,1,6.83-1L392,355.42A3.44,3.44,0,0,1,389.07,359.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M387.77,358.35l-6.55-45.53a3.45,3.45,0,0,1,2.92-3.9,3.34,3.34,0,0,1,1,0,3.44,3.44,0,0,0-6.53,1.93l6.55,45.53a3.45,3.45,0,0,0,2.91,2.91A3.36,3.36,0,0,1,387.77,358.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M407.28,356.71a3.45,3.45,0,0,1-3.9-2.93l-6.55-45.53a3.45,3.45,0,0,1,6.83-1l6.55,45.53A3.45,3.45,0,0,1,407.28,356.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M406,355.73l-6.55-45.53a3.45,3.45,0,0,1,2.92-3.9,3.33,3.33,0,0,1,1,0,3.43,3.43,0,0,0-6.52,1.93l6.55,45.53a3.44,3.44,0,0,0,2.9,2.91A3.36,3.36,0,0,1,406,355.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M425.49,354.09a3.45,3.45,0,0,1-3.9-2.93L415,305.63a3.45,3.45,0,0,1,6.83-1l6.55,45.53A3.45,3.45,0,0,1,425.49,354.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M424.19,353.11l-6.55-45.53a3.45,3.45,0,0,1,2.93-3.9,3.35,3.35,0,0,1,1,0,3.44,3.44,0,0,0-6.53,1.93l6.55,45.53a3.44,3.44,0,0,0,2.9,2.91A3.46,3.46,0,0,1,424.19,353.11Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 304.9,
    cy: 168.78,
    r: 22.47,
    transform: "translate(50.28 406.73) rotate(-72.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M307.67,146.5A25.92,25.92,0,0,1,318.4,164l-35.95,5.18a24.31,24.31,0,0,0,.21,2.8l44.48-6.4A22.46,22.46,0,0,0,307.67,146.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M298,156.06a3.75,3.75,0,1,1-4.24-3.17A3.75,3.75,0,0,1,298,156.06Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 360.5,
    cy: 160.78,
    r: 22.47,
    transform: "translate(17.29 355.77) rotate(-53.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M363.27,138.5A25.88,25.88,0,0,1,374,156l-35.94,5.18a22.23,22.23,0,0,0,.2,2.8l44.48-6.4A22.46,22.46,0,0,0,363.27,138.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M353.59,148.06a3.74,3.74,0,1,1-4.24-3.17A3.75,3.75,0,0,1,353.59,148.06Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 416.11,
    cy: 152.78,
    r: 22.47,
    transform: "translate(43.05 392.2) rotate(-52.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M418.87,130.5A25.93,25.93,0,0,1,429.61,148l-35.95,5.18a22.23,22.23,0,0,0,.2,2.8l44.49-6.4A22.48,22.48,0,0,0,418.87,130.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M409.19,140.06a3.74,3.74,0,1,1-4.24-3.17A3.74,3.74,0,0,1,409.19,140.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "428.91 241.75 317.7 257.75 317.7 257.75 304.9 168.78 416.11 152.78 428.91 241.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M304.9,168.78l-32.08,4.62a12.53,12.53,0,0,0-10.62,14.18l9.24,64.17a12.51,12.51,0,0,0,14.18,10.61l32.08-4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M422.28,149.13h32.42a12.52,12.52,0,0,1,12.52,12.52v64.83A12.52,12.52,0,0,1,454.69,239H422.28a0,0,0,0,1,0,0V149.13a0,0,0,0,1,0,0Z",
    transform: "translate(-23.1 65.32) rotate(-8.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M327.14,165.58l4.8,33.36a33.7,33.7,0,1,0,66.72-9.6L393.86,156Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M383.37,191.54a18.26,18.26,0,1,1-20.67-15.47A18.25,18.25,0,0,1,383.37,191.54Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365.3,
    cy: 194.14,
    r: 12.64,
    transform: "translate(122.73 529.25) rotate(-82.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M361,237.16c-.23-8.31,6.86-9.08,6.59-14.25s-6.63-7.81-7-11.58c-.73-6.79,6-8.38,6-8.38"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 361.01,
    cy: 243.4,
    r: 12.64,
    transform: "translate(116.34 603.55) rotate(-89.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M362.34,252.21a13.67,13.67,0,0,1-10.45-2.82,10.82,10.82,0,0,0,19.68-2.83A13.67,13.67,0,0,1,362.34,252.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M359.4,232.22A11.29,11.29,0,0,0,349.84,245a11.5,11.5,0,0,0,.92,3.12,42.1,42.1,0,0,0,21.42-3.08,11.48,11.48,0,0,0,0-3.26A11.31,11.31,0,0,0,359.4,232.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M359.47,240.28a3.63,3.63,0,1,1-4.11-3.08A3.62,3.62,0,0,1,359.47,240.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M368.08,248.26a1.87,1.87,0,1,1-2.12-1.58A1.88,1.88,0,0,1,368.08,248.26Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 511.87,
    cy: 581.67,
    r: 22.47,
    transform: "translate(-236.93 382.53) rotate(-33.76)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 511.87,
    cy: 581.68,
    r: 14.51,
    transform: "translate(-121.55 1027.93) rotate(-83.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M508.67,559.43a22.43,22.43,0,0,0-17.52,30.9l43-6.19a22.94,22.94,0,0,0-.07-5.67A22.48,22.48,0,0,0,508.67,559.43Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 456.26,
    cy: 589.67,
    r: 22.47,
    transform: "translate(-288.42 626.31) rotate(-55.08)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 456.26,
    cy: 589.67,
    r: 14.51,
    transform: "translate(-22.24 17.9) rotate(-2.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M453.06,567.43a22.48,22.48,0,0,0-19,25.44,22.72,22.72,0,0,0,1.53,5.46l43-6.19a22.94,22.94,0,0,0-.07-5.67A22.48,22.48,0,0,0,453.06,567.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "545.23 576.88 300.58 612.08 295.78 578.71 325.94 551.67 503.87 526.07 540.43 543.51 545.23 576.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "503.87 526.07 483.62 528.99 509.85 547.91 514.65 581.27 545.23 576.88 540.43 543.51 503.87 526.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "482.69 534.38 329.06 556.49 309.1 576.8 500.26 549.29 482.69 534.38"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 126.14,
    cy: 589.67,
    r: 22.47,
    transform: "translate(-421.54 337.33) rotate(-53.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M140.5,587.61a14.51,14.51,0,1,1-16.43-12.3A14.51,14.51,0,0,1,140.5,587.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 591.25,
    width: 44.94,
    height: 20.9,
    rx: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M41.94,591.58v12a3.53,3.53,0,0,1-3.52,3.53H.53a3.07,3.07,0,0,1-.53-.06v.35a4.71,4.71,0,0,0,4.7,4.71H40.24a4.7,4.7,0,0,0,4.7-4.71V596A4.68,4.68,0,0,0,41.94,591.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M479,139.37c14.8-17.71,26.23-39.91-9.36-52.4-25.35-8.9-20.93-28.2-6-40.2C483.12,31.18,519.84,10.17,491.43,0c20.57.34,25.46,16.4,14.84,32-15.73,23-36.7,26.77-15,41.28C506,83.14,531.07,103.42,479,139.37Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenRobot);
export default __webpack_public_path__ + "static/media/broken-robot.a222b34b90b966b2fcc2e7006a96efad.svg";
export { ForwardRef as ReactComponent };